module.exports = __webpack_public_path__ + "img/collar_button_diameter.ae0466c4.png";